import React from "react";
import { useTranslation } from "react-i18next";

import ViewContainer from "../../components/ViewContainer";
import Placeholder from "../../components/Placeholder";
import { useVariant } from "../../variants/useVariant";

// HU-2 — Recorrido: embudo de 6 fases con retencion/caida y 2 puntos de fuga criticos.
function JourneyView() {
    const { t } = useTranslation();
    const { variant } = useVariant("journey");

    return (
        <ViewContainer title={t("views.journey.title")}>
            {variant ? variant.render() : <Placeholder />}
        </ViewContainer>
    );
}

export default JourneyView;
